import React from 'react';
const FREE_IMG = 'https://cdn.magicpatterns.com/uploads/7BZ7MEdgEj6PGCPaGgifZt/Free.png';
export function Hero() {
  return <section className="px-4 md:px-8 py-8 max-w-7xl mx-auto" data-id="element-149">
      <div className="bg-[#F0F0F3] rounded-[2.5rem] p-8 md:p-16 flex flex-col lg:flex-row items-center gap-8 overflow-hidden relative min-h-[500px] lg:min-h-[600px]" data-id="element-150">
        {/* Left content */}
        <div className="flex-1 z-10 text-center lg:text-left" data-id="element-151">
          <h1 className="mb-8" data-id="element-152">
            <span className="text-hero-black block pl-[50px] pr-[50px] text-[70px]" data-id="element-153">
              Vende más,
            </span>
            <span className="text-hero-blue block italic text-[65px]" data-id="element-154">
              trabaja menos.
            </span>
          </h1>
          <p className="text-body !text-gray-600 mb-10 max-w-lg mx-auto lg:mx-0 text-center lg:text-left" data-id="element-155">
            Centraliza tu marketing, ventas y operaciones. Reemplaza el caos de
            múltiples suscripciones por un ecosistema diseñado para escalar.
          </p>
          <div className="flex justify-center lg:justify-start" data-id="element-156">
            <a href="https://valuancrm.com/prueba-gratuita" className="text-btn bg-[#1F46D5] px-10 py-5 rounded-2xl hover:bg-[#152E8A] transition-transform hover:scale-105 shadow-lg shadow-[#1F46D5]/20 !text-[20px] inline-block text-center" data-id="element-157">
              Pruébalo Gratis 7 Días
            </a>
          </div>
        </div>

        {/* Right — laptop image */}
        <div className="flex-1 w-full relative z-10 mt-8 lg:mt-0 flex justify-center lg:justify-end" data-id="element-158">
          <img src={FREE_IMG} alt="Valuan CRM Dashboard" className="w-full max-w-2xl lg:max-w-none lg:w-[120%] lg:absolute lg:right-[-10%] lg:top-1/2 lg:-translate-y-1/2 object-contain drop-shadow-2xl" data-id="element-159" />
        </div>
      </div>
    </section>;
}